/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!**************************************!*\
  !*** ./src/assets/js/cart-drawer.js ***!
  \**************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CartDrawer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartDrawer, _HTMLElement);

  var _super = _createSuper(CartDrawer);

  function CartDrawer() {
    var _this;

    _classCallCheck(this, CartDrawer);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleCartSync", _this.debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var cartSettings, _updatedCart;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getCartJson();

            case 3:
              cartSettings = _context.sent;
              console.log(cartSettings, 'cartSettings');
              _context.next = 7;
              return _this.syncPromoProducts(cartSettings.items);

            case 7:
              _context.next = 9;
              return _this.syncAdditionalProducts(cartSettings.items);

            case 9:
              _context.next = 11;
              return _this.checkFreeProducts();

            case 11:
              _context.prev = 11;
              _context.next = 14;
              return fetch("".concat(window.location.origin, "/cart.js")).then(function (res) {
                return res.json();
              });

            case 14:
              _updatedCart = _context.sent;
              return _context.abrupt("return", _updatedCart);

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](11);
              console.error('Error fetching updated cart:', _context.t0);

            case 21:
              console.log('Updated cart contents:', updatedCart);
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t1 = _context["catch"](0);
              console.error('Error in handleCartSync:', _context.t1);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 24], [11, 18]]);
    })), 500));

    _this.selectors = {
      bottomFreeProducts: {
        wrapper: '.free-products-bottom',
        productBlock: '.free-products-bottom__product-card--wrapper',
        productCard: '.free-products-bottom__product-card',
        productCardCta: '.free-products-bottom__product-card-cta',
        progress: '.free-products-bottom__progressbar__progress',
        progressLabel: '.free-products-bottom__progressbar__label'
      }
    };
    _this.modificators = {
      showFreeBottomProducts: 'products-show',
      showFreeBottomProgress: 'progressbar-show',
      showFreeBottomSuccess: 'complete-show',
      hidden: 'hidden-block'
    };
    _this.state = {
      freeProducts: [],
      freeBottomProducts: [],
      paidProducts: 0,
      addedFreeProducts: {},
      freeProductsFlags: {},
      progressLabels: {},
      promoProducts: [],
      checkInProgress: false
    };
    _this.drawer = _this.querySelector('#cart-drawer');
    _this.checkoutButton = _this.querySelector('[name="checkout"]');
    _this.reserveTimer = _this.querySelectorAll('reserve-timer');

    _this.addEventListener('keyup', function (evt) {
      return evt.code === 'Escape' && _this.close();
    });

    _this.querySelectorAll('[data-close-cart]').forEach(function (el) {
      return el.addEventListener('click', _this.close.bind(_assertThisInitialized(_this)));
    });

    _this.animating = false;
    _this.canOpen = true;
    _this.freeProductForAdd = [];
    _this.freeProductForRemove = [];
    _this.percent = 0;
    _this.bottomPercent = 0;
    _this.percentElement = _this.querySelector('.cart-drawer__free-products__progress-bar');

    if (_this.percent === 0 && _this.querySelector('.cart-drawer__free-products__progress-bar')) {
      _this.percent = _this.querySelector('.cart-drawer__free-products__progress-bar').getAttribute('data-percent');
      _this.querySelector('.cart-drawer__free-products__progress-bar .cart-drawer__free-products__progress').style.width = "".concat(_this.percent, "%");
    }

    return _this;
  }

  _createClass(CartDrawer, [{
    key: "updateProgressBar",
    value: function updateProgressBar() {
      if (this.querySelector('.cart-drawer__free-products__progress-bar')) {
        this.percent = this.querySelector('.cart-drawer__free-products__progress-bar').getAttribute('data-percent');
        this.querySelector('.cart-drawer__free-products__progress-bar .cart-drawer__free-products__progress').style.width = "".concat(this.percent, "%");
      }
    }
  }, {
    key: "updateBottomProgressBar",
    value: function updateBottomProgressBar() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.querySelector('.free-products-bottom__progressbar .free-products-bottom__progressbar__progress')) {
          _this2.querySelector('.free-products-bottom__progressbar .free-products-bottom__progressbar__progress').style.width = "".concat(_this2.bottomPercent, "%");
        }
      }, 200);
    }
  }, {
    key: "debounce",
    value: function debounce(func, delay) {
      var timeoutId;
      return function () {
        var _this3 = this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          return func.apply(_this3, args);
        }, delay);
      };
    }
  }, {
    key: "preventOpen",
    value: function preventOpen(stop) {
      if (stop == undefined) {
        stop = true;
      }

      this.canOpen = !stop;
    }
  }, {
    key: "open",
    value: function open(triggeredBy) {
      this.updateProgressBar();
      this.updateBottomProgressBar();

      if (this.animating || !this.canOpen) {
        return;
      }

      this.animating = true;
      if (triggeredBy) this.setActiveElement(triggeredBy);
    }
  }, {
    key: "close",
    value: function close() {
      if (this.animating) {
        return;
      }
    }
  }, {
    key: "removeFreeProductFromState",
    value: function removeFreeProductFromState(variantId) {
      for (var _i = 0, _Object$entries = Object.entries(this.state.addedFreeProducts); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value.includes(variantId)) {
          delete this.state.addedFreeProducts[key];
        }
      }

      localStorage.setItem('addedFreeProducts', JSON.stringify(this.state.addedFreeProducts));
    }
  }, {
    key: "removeFreeProductFromCart",
    value: function removeFreeProductFromCart(variantId, quantity) {
      var _document$querySelect,
          _this4 = this;

      var updates = _defineProperty({}, variantId, quantity);

      var data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          sections: this.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        })
      };
      (_document$querySelect = document.querySelector('.cart-checkout-btn')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.setAttribute('disabled', 'disabled');
      setTimeout(function () {
        return fetch("".concat(window.location.origin, "/cart/update.js"), data).then(function (response) {
          return response.json();
        }).then(function (response) {
          var _document$querySelect2;

          _this4.removeFreeProductFromState(variantId);

          _this4.renderContents(response);

          (_document$querySelect2 = document.querySelector('.cart-checkout-btn')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.removeAttribute('disabled');
        });
      }, 500);
    }
  }, {
    key: "syncAdditionalProducts",
    value: function syncAdditionalProducts(items) {
      var _this5 = this;

      console.log('sync additional prods', items);
      items.forEach(function (item) {
        if (item.properties) {
          var hideQuantityProperty = item.properties.find(function (property) {
            return property[0] === '__hide_quantity';
          });

          if (hideQuantityProperty) {
            var mainProductId = parseInt(hideQuantityProperty[1]);
            var mainProductExists = items.some(function (mainItem) {
              return mainItem.variant_id == mainProductId;
            });
            console.log(mainProductExists, mainProductId);

            if (!mainProductExists) {
              console.log("Removing item with variant_id ".concat(item.variant_id, " because main product ").concat(mainProductId, " is not in the cart."));

              _this5.removeFreeProductFromCart(item.variant_id, 0);
            }
          }
        }
      });
    }
  }, {
    key: "addToCartCustomProductS",
    value: function addToCartCustomProductS(products_object) {
      var _this6 = this;

      var data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: products_object,
          sections: this.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        })
      };
      setTimeout(function () {
        return fetch("".concat(window.location.origin, "/cart/add.js"), data).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (_this6.state.paidProducts >= 3 && !_this6.state.addedFreeProducts['3']) {
            _this6.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this6.state.addedFreeProducts), {}, {
              3: id
            });
          } else if (_this6.state.paidProducts >= 6 && !_this6.state.addedFreeProducts['6']) {
            _this6.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this6.state.addedFreeProducts), {}, {
              6: id
            });
          } else if (_this6.state.paidProducts >= 9 && !_this6.state.addedFreeProducts['9']) {
            _this6.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this6.state.addedFreeProducts), {}, {
              9: id
            });
          }

          localStorage.setItem('addedFreeProducts', JSON.stringify(_this6.state.addedFreeProducts));

          _this6.renderContents(response);

          document.querySelector('#cart-icon-bubble-desktop').click();

          _this6.checkFreeProducts();
        });
      }, 500);
    }
  }, {
    key: "addToCartProduct",
    value: function addToCartProduct(id, quantity) {
      var _this7 = this;

      var data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: id,
            quantity: quantity
          }],
          sections: this.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        })
      };
      setTimeout(function () {
        return fetch("".concat(window.location.origin, "/cart/add.js"), data).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (_this7.state.paidProducts >= 3 && !_this7.state.addedFreeProducts['3']) {
            _this7.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this7.state.addedFreeProducts), {}, {
              3: id
            });
          } else if (_this7.state.paidProducts >= 6 && !_this7.state.addedFreeProducts['6']) {
            _this7.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this7.state.addedFreeProducts), {}, {
              6: id
            });
          } else if (_this7.state.paidProducts >= 9 && !_this7.state.addedFreeProducts['9']) {
            _this7.state.addedFreeProducts = _objectSpread(_objectSpread({}, _this7.state.addedFreeProducts), {}, {
              9: id
            });
          }

          localStorage.setItem('addedFreeProducts', JSON.stringify(_this7.state.addedFreeProducts));

          _this7.renderContents(response);
        });
      }, 500);
    }
  }, {
    key: "addToCartFreeProduct",
    value: function () {
      var _addToCartFreeProduct = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(product) {
        var data, response, responseData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    items: [{
                      id: product.id,
                      quantity: product.quantity
                    }],
                    sections: this.getSectionsToRender().map(function (section) {
                      return section.id;
                    }),
                    sections_url: window.location.pathname
                  })
                };
                _context2.prev = 1;
                _context2.next = 4;
                return fetch("".concat(window.location.origin, "/cart/add.js"), data);

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();

              case 7:
                responseData = _context2.sent;
                this.renderContents(responseData);
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                console.error('Error adding free product to cart:', _context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 11]]);
      }));

      function addToCartFreeProduct(_x) {
        return _addToCartFreeProduct.apply(this, arguments);
      }

      return addToCartFreeProduct;
    }()
  }, {
    key: "removeFromCartFreeProduct",
    value: function () {
      var _removeFromCartFreeProduct = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(productId) {
        var updates, data, response, responseData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                updates = _defineProperty({}, productId, 0);
                data = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    updates: updates,
                    sections: this.getSectionsToRender().map(function (section) {
                      return section.id;
                    }),
                    sections_url: window.location.pathname
                  })
                };
                _context3.prev = 2;
                _context3.next = 5;
                return fetch("".concat(window.location.origin, "/cart/update.js"), data);

              case 5:
                response = _context3.sent;
                _context3.next = 8;
                return response.json();

              case 8:
                responseData = _context3.sent;
                this.renderContents(responseData);
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](2);
                console.error('Error removing free product from cart:', _context3.t0);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 12]]);
      }));

      function removeFromCartFreeProduct(_x2) {
        return _removeFromCartFreeProduct.apply(this, arguments);
      }

      return removeFromCartFreeProduct;
    }()
  }, {
    key: "addToCartFreeProducts",
    value: function () {
      var _addToCartFreeProducts = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(products) {
        var itemsToAdd, data, response, responseData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                itemsToAdd = products.map(function (item) {
                  return {
                    id: item.id,
                    quantity: item.quantity
                  };
                });
                data = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    items: itemsToAdd,
                    sections: this.getSectionsToRender().map(function (section) {
                      return section.id;
                    }),
                    sections_url: window.location.pathname
                  })
                };
                _context4.prev = 2;
                _context4.next = 5;
                return fetch("".concat(window.location.origin, "/cart/add.js"), data);

              case 5:
                response = _context4.sent;
                _context4.next = 8;
                return response.json();

              case 8:
                responseData = _context4.sent;
                this.renderContents(responseData);
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                console.error('Error adding free products to cart:', _context4.t0);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 12]]);
      }));

      function addToCartFreeProducts(_x3) {
        return _addToCartFreeProducts.apply(this, arguments);
      }

      return addToCartFreeProducts;
    }()
  }, {
    key: "removeFromCartFreeProducts",
    value: function () {
      var _removeFromCartFreeProducts = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(productIds) {
        var updates, data, response, responseData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                updates = productIds.reduce(function (acc, id) {
                  acc[id] = 0;
                  return acc;
                }, {});
                data = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    updates: updates,
                    sections: this.getSectionsToRender().map(function (section) {
                      return section.id;
                    }),
                    sections_url: window.location.pathname
                  })
                };
                _context5.prev = 2;
                _context5.next = 5;
                return fetch("".concat(window.location.origin, "/cart/update.js"), data);

              case 5:
                response = _context5.sent;
                _context5.next = 8;
                return response.json();

              case 8:
                responseData = _context5.sent;
                this.renderContents(responseData);
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](2);
                console.error('Error removing free products from cart:', _context5.t0);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 12]]);
      }));

      function removeFromCartFreeProducts(_x4) {
        return _removeFromCartFreeProducts.apply(this, arguments);
      }

      return removeFromCartFreeProducts;
    }()
  }, {
    key: "getCartJson",
    value: function () {
      var _getCartJson = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
        var response, textResponse, html, settings;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetch("".concat(routes.cart_url, "?view=ajax-cart"), {
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  method: 'GET'
                });

              case 2:
                response = _context6.sent;
                _context6.next = 5;
                return response.text();

              case 5:
                textResponse = _context6.sent;
                html = new DOMParser().parseFromString(textResponse, 'text/html');
                settings = JSON.parse(html.querySelector('[data-cart-settings]').innerHTML);
                return _context6.abrupt("return", settings);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getCartJson() {
        return _getCartJson.apply(this, arguments);
      }

      return getCartJson;
    }()
  }, {
    key: "showFreeBottomProducts",
    value: function showFreeBottomProducts() {
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomProgress);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomSuccess);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.add(this.modificators.showFreeBottomProducts);
    }
  }, {
    key: "showFreeBottomProgress",
    value: function showFreeBottomProgress(nextBlock) {
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.add(this.modificators.showFreeBottomProgress);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomSuccess);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomProducts);
      var progressLabel = this.querySelector(this.selectors.bottomFreeProducts.progressLabel);

      if (this.state.paidProducts < 3) {
        this.bottomPercent = 33.3 * this.state.paidProducts;
        var productCount = 3 - this.state.paidProducts;
        progressLabel.textContent = "".concat(this.state.progressLabels[productCount]);
      } else {
        var percent = this.state.paidProducts / 3 % 1 * 100;
        percent == 0 ? percent = 100 : null;

        if (percent == 100 && nextBlock) {
          progressLabel.textContent = "".concat(this.state.progressLabels['3']);
          this.bottomPercent = 0;
        } else {
          if (percent > 33 && percent < 66) {
            progressLabel.textContent = "".concat(this.state.progressLabels['2']);
            this.bottomPercent = percent;
          } else if (percent > 66 && percent < 100) {
            this.bottomPercent = percent;
            progressLabel.textContent = "".concat(this.state.progressLabels['1']);
          } else {
            this.bottomPercent = percent;
          }
        }
      }

      this.updateBottomProgressBar();
    }
  }, {
    key: "showFreeBottomSuccess",
    value: function showFreeBottomSuccess() {
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomProgress);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.add(this.modificators.showFreeBottomSuccess);
      this.querySelector(this.selectors.bottomFreeProducts.wrapper).classList.remove(this.modificators.showFreeBottomProducts);
    }
  }, {
    key: "handleFreeProductsInCart",
    value: function handleFreeProductsInCart() {
      var _this8 = this;

      var addedFreeProducts = Object.keys(this.state.addedFreeProducts);
      addedFreeProducts.forEach(function (key, index) {
        if (_this8.state.paidProducts < key) {
          var _id = _this8.state.addedFreeProducts[key];
          setTimeout(function () {
            _this8.removeFreeProductFromCart(_id, 0);
          }, 400 * index);
        }
      });
    }
  }, {
    key: "handlePaidProductsCount",
    value: function handlePaidProductsCount() {
      this.handleFreeProductsInCart(); // Success cart

      if (this.state.addedFreeProducts['3'] && this.state.addedFreeProducts['6'] && this.state.addedFreeProducts['9']) {
        this.showFreeBottomSuccess();
        return;
      } // Empty cart


      if (this.state.paidProducts == 0) {
        this.showFreeBottomProgress();
        return;
      } // 3 Products


      if (this.state.paidProducts < 3 && !this.state.addedFreeProducts['3']) {
        this.showFreeBottomProgress();
        return;
      } else if (this.state.paidProducts == 3 && this.state.addedFreeProducts['3']) {
        this.showFreeBottomProgress(true);
        return;
      } else if (this.state.paidProducts == 3 && !this.state.addedFreeProducts['3']) {
        this.showFreeBottomProducts();
      } // 6 Products


      if (this.state.paidProducts > 3 && this.state.paidProducts < 6) {
        if (this.state.addedFreeProducts['3']) {
          this.showFreeBottomProgress();
          return;
        } else {
          this.showFreeBottomProducts();
          return;
        }
      } else if (this.state.paidProducts == 6 && !this.state.addedFreeProducts['6']) {
        this.showFreeBottomProducts();
        return;
      } // 9 Products


      if (this.state.paidProducts > 3 && this.state.paidProducts < 9) {
        if (this.state.addedFreeProducts['3'] && this.state.addedFreeProducts['6']) {
          this.showFreeBottomProgress(true);
          return;
        } else {
          this.showFreeBottomProducts();
          return;
        }
      } else if (this.state.paidProducts >= 9 && !this.state.addedFreeProducts['9']) {
        this.showFreeBottomProducts();
        return;
      }
    }
  }, {
    key: "checkPaidProducts",
    value: function checkPaidProducts() {
      this.state.paidProducts = _toConsumableArray(this.querySelectorAll('cart-drawer-item')).reduce(function (acc, item) {
        acc += +item.dataset.quantity;
        return acc;
      }, 0);
    }
  }, {
    key: "isPromoActive",
    value: function isPromoActive(promoEndDate, promoEndTime, promoTimeZone) {
      if (!promoEndDate || !promoEndTime || !promoTimeZone) {
        return true; // If any promo details are missing, consider the promo as active
      } // Convert the promo end date and time to a proper Date object


      var promoEndDateParts = promoEndDate.split('/');
      var formattedPromoEndDate = "".concat(promoEndDateParts[2], "-").concat(promoEndDateParts[1], "-").concat(promoEndDateParts[0], " ").concat(promoEndTime);
      var promoEndDateTime = new Date("".concat(formattedPromoEndDate, " ").concat(promoTimeZone)); // Check if the promo end date and time is in the future

      return new Date() <= promoEndDateTime;
    }
  }, {
    key: "checkFreeProducts",
    value: function () {
      var _checkFreeProducts = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        var _document$querySelect3;

        var response, _yield$response$json, items, original_total_price, comparableCartTotal, updates, needsUpdate, _document$querySelect4;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.state.checkInProgress) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                this.state.checkInProgress = true;
                (_document$querySelect3 = document.querySelector('.cart-checkout-btn')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.setAttribute('disabled', 'disabled');
                _context7.prev = 4;
                _context7.next = 7;
                return fetch("".concat(window.location.origin, "/cart.js"));

              case 7:
                response = _context7.sent;
                _context7.next = 10;
                return response.json();

              case 10:
                _yield$response$json = _context7.sent;
                items = _yield$response$json.items;
                original_total_price = _yield$response$json.original_total_price;
                comparableCartTotal = Math.round(original_total_price / 100);
                updates = {};
                needsUpdate = false;

                if (comparableCartTotal === 0) {
                  // Remove all free products if there are no paid items
                  items.forEach(function (item) {
                    if (item.price === 0) {
                      updates[item.variant_id] = 0;
                      needsUpdate = true;
                    }
                  });
                } else {
                  // Existing logic for managing free products
                  this.state.freeProducts.forEach(function (product) {
                    var productInCart = items.find(function (item) {
                      return item.variant_id === product.productId;
                    });

                    if (productInCart) {
                      if (comparableCartTotal < product.price || productInCart.quantity > 1) {
                        updates[product.productId] = 0;
                        needsUpdate = true;
                      }
                    } else if (comparableCartTotal >= product.price) {
                      updates[product.productId] = 1;
                      needsUpdate = true;
                    }
                  });
                }

                if (!needsUpdate) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 20;
                return this.updateCart(updates);

              case 20:
                _context7.next = 25;
                break;

              case 22:
                _context7.prev = 22;
                _context7.t0 = _context7["catch"](4);
                console.error('Error checking free products:', _context7.t0);

              case 25:
                _context7.prev = 25;
                this.state.checkInProgress = false;
                (_document$querySelect4 = document.querySelector('.cart-checkout-btn')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.removeAttribute('disabled');
                return _context7.finish(25);

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 22, 25, 29]]);
      }));

      function checkFreeProducts() {
        return _checkFreeProducts.apply(this, arguments);
      }

      return checkFreeProducts;
    }()
  }, {
    key: "processFreeProductQueue",
    value: function () {
      var _processFreeProductQueue = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.freeProductForRemove.length) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.removeFromCartFreeProducts(this.freeProductForRemove);

              case 3:
                if (!this.freeProductForAdd.length) {
                  _context8.next = 6;
                  break;
                }

                _context8.next = 6;
                return this.addToCartFreeProducts(this.freeProductForAdd);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function processFreeProductQueue() {
        return _processFreeProductQueue.apply(this, arguments);
      }

      return processFreeProductQueue;
    }()
  }, {
    key: "renderContents",
    value: function () {
      var _renderContents = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(parsedState) {
        var _this9 = this;

        var updatedSections;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                updatedSections = new Set();
                this.getSectionsToRender().forEach(function (section) {
                  if (section.selectors) {
                    section.selectors.forEach(function (selector) {
                      var sectionElement = document.querySelector(selector);

                      if (sectionElement) {
                        var newContent = _this9.getSectionInnerHTML(parsedState.sections[section.id], selector);

                        if (sectionElement.innerHTML !== newContent) {
                          sectionElement.innerHTML = newContent;
                          updatedSections.add(section.id);
                        }
                      }
                    });
                  } else {
                    var sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

                    if (sectionElement) {
                      var newContent = _this9.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

                      if (sectionElement.innerHTML !== newContent) {
                        sectionElement.innerHTML = newContent;
                        updatedSections.add(section.id);
                      }
                    }
                  }
                });

                if (updatedSections.size > 0) {
                  if (this.querySelector(this.selectors.bottomFreeProducts.wrapper)) {
                    this.checkPaidProducts();
                    this.handlePaidProductsCount();
                    this.initListeners();
                  }

                  this.handleCartSync();
                }

                this.open();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function renderContents(_x5) {
        return _renderContents.apply(this, arguments);
      }

      return renderContents;
    }()
  }, {
    key: "syncPromoProducts",
    value: function () {
      var _syncPromoProducts = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(items) {
        var _this10 = this;

        var updates, hasRegularItems, promoProductsToAdd, _iterator, _step, _loop;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('syncPromoProducts', items);

                if (!this.isSyncingPromo) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return");

              case 3:
                this.isSyncingPromo = true;
                updates = {};
                hasRegularItems = false;
                promoProductsToAdd = [];
                _iterator = _createForOfIteratorHelper(items);

                try {
                  _loop = function _loop() {
                    var item = _step.value;

                    if (item.price > 0) {
                      hasRegularItems = true;
                    }

                    console.log(item, 'item');
                    console.log(_this10.isPromoActive(item.promo_end_date, item.promo_end_time, item.promo_time_zone), 'is promo active');
                    console.log(item.promo_product, 'item.promo_product');

                    if (item.promo_product && _this10.isPromoActive(item.promo_end_date, item.promo_end_time, item.promo_time_zone)) {
                      var promoProductInCart = items.find(function (i) {
                        return i.variant_id === parseInt(item.promo_product);
                      });
                      console.log(promoProductInCart, 'promoProductInCart');

                      if (!promoProductInCart) {
                        promoProductsToAdd.push({
                          id: parseInt(item.promo_product),
                          quantity: item.quantity,
                          properties: {
                            __ParentProduct: item.variant_id
                          }
                        });
                      } else if (promoProductInCart.quantity !== item.quantity) {
                        updates[item.promo_product] = item.quantity;
                      }
                    }
                  };

                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                console.log('Final promoProductsToAdd:', promoProductsToAdd);
                console.log(hasRegularItems, 'hasRegularItems');

                if (hasRegularItems) {
                  _context10.next = 15;
                  break;
                }

                // If there are no regular items, remove all free/promo items
                items.forEach(function (item) {
                  if (item.price === 0 || item.properties && item.properties['__ParentProduct']) {
                    updates[item.variant_id] = 0;
                  }
                });
                _context10.next = 19;
                break;

              case 15:
                if (!(promoProductsToAdd.length > 0)) {
                  _context10.next = 19;
                  break;
                }

                console.log('Calling addPromoProductsToCart');
                _context10.next = 19;
                return this.addPromoProductsToCart(promoProductsToAdd);

              case 19:
                if (!(Object.keys(updates).length > 0)) {
                  _context10.next = 23;
                  break;
                }

                console.log('Calling updateCart with updates:', updates);
                _context10.next = 23;
                return this.updateCart(updates);

              case 23:
                this.isSyncingPromo = false;

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function syncPromoProducts(_x6) {
        return _syncPromoProducts.apply(this, arguments);
      }

      return syncPromoProducts;
    }()
  }, {
    key: "addPromoProductsToCart",
    value: function () {
      var _addPromoProductsToCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(products) {
        var data, response, responseData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                console.log('Attempting to add promo products:', products);
                data = {
                  items: products,
                  sections: this.getSectionsToRender().map(function (section) {
                    return section.id;
                  }),
                  sections_url: window.location.pathname
                };
                _context11.prev = 2;
                _context11.next = 5;
                return fetch("".concat(window.location.origin, "/cart/add.js"), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data)
                });

              case 5:
                response = _context11.sent;
                _context11.next = 8;
                return response.json();

              case 8:
                responseData = _context11.sent;
                console.log('Promo products add response:', responseData);

                if (!(responseData.status && responseData.status !== 200)) {
                  _context11.next = 14;
                  break;
                }

                console.error('Error adding promo products:', responseData.description);
                _context11.next = 16;
                break;

              case 14:
                _context11.next = 16;
                return this.renderContents(responseData);

              case 16:
                _context11.next = 21;
                break;

              case 18:
                _context11.prev = 18;
                _context11.t0 = _context11["catch"](2);
                console.error('Error adding promo products to cart:', _context11.t0);

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 18]]);
      }));

      function addPromoProductsToCart(_x7) {
        return _addPromoProductsToCart.apply(this, arguments);
      }

      return addPromoProductsToCart;
    }()
  }, {
    key: "updateCart",
    value: function () {
      var _updateCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(updates) {
        var data, response, responseData, _document$querySelect5;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                data = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    updates: updates,
                    sections: this.getSectionsToRender().map(function (section) {
                      return section.id;
                    }),
                    sections_url: window.location.pathname
                  })
                };
                _context12.prev = 1;
                _context12.next = 4;
                return fetch("".concat(window.location.origin, "/cart/update.js"), data);

              case 4:
                response = _context12.sent;
                _context12.next = 7;
                return response.json();

              case 7:
                responseData = _context12.sent;
                _context12.next = 10;
                return this.renderContents(responseData);

              case 10:
                _context12.next = 12;
                return this.handleCartSync();

              case 12:
                _context12.next = 17;
                break;

              case 14:
                _context12.prev = 14;
                _context12.t0 = _context12["catch"](1);
                console.error('Error updating cart:', _context12.t0);

              case 17:
                _context12.prev = 17;
                (_document$querySelect5 = document.querySelector('.cart-checkout-btn')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.removeAttribute('disabled');
                return _context12.finish(17);

              case 20:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[1, 14, 17, 20]]);
      }));

      function updateCart(_x8) {
        return _updateCart.apply(this, arguments);
      }

      return updateCart;
    }()
  }, {
    key: "addToCartWithProperties",
    value: function addToCartWithProperties(id, quantity, properties) {
      var _this11 = this;

      var data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: id,
            quantity: quantity,
            properties: properties
          }],
          sections: this.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        })
      };
      setTimeout(function () {
        return fetch("".concat(window.location.origin, "/cart/add.js"), data).then(function (response) {
          return response.json();
        }).then(function (response) {
          _this11.renderContents(response);
        });
      }, 500);
    }
  }, {
    key: "getSectionInnerHTML",
    value: function getSectionInnerHTML(html) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
      var parsedDom = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

      if (parsedDom.querySelector('.cart-drawer__free-products__progress-bar .cart-drawer__free-products__progress')) {
        parsedDom.querySelector('.cart-drawer__free-products__progress-bar .cart-drawer__free-products__progress').style.width = "".concat(this.percent, "%");
      }

      if (parsedDom.querySelector('.free-products-bottom__progressbar .free-products-bottom__progressbar__progress')) {
        parsedDom.querySelector('.free-products-bottom__progressbar .free-products-bottom__progress').style.width = "".concat(this.bottomPercent, "%");
      }

      return parsedDom.innerHTML;
    }
  }, {
    key: "getSectionsToRender",
    value: function getSectionsToRender() {
      return [{
        id: 'cart-drawer',
        selectors: ['#cart-drawer .cart-content']
      }, {
        id: 'v2-header',
        selectors: ['#header #cart-icon-bubble']
      }, {
        id: 'v2-header',
        selectors: ['#header #cart-icon-bubble-desktop']
      }, {
        id: 'header-pdp',
        selectors: ['#header-pdp #cart-icon-bubble']
      }, {
        id: 'header-pdp',
        selectors: ['#header-pdp #cart-icon-bubble-desktop']
      }];
    }
  }, {
    key: "getSectionDOM",
    value: function getSectionDOM(html) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
  }, {
    key: "setActiveElement",
    value: function setActiveElement(element) {
      this.activeElement = element;
    }
  }, {
    key: "setBottomFreeProducts",
    value: function setBottomFreeProducts() {
      var products = this.querySelectorAll(this.selectors.bottomFreeProducts.productCard);
      var localStorageParse = JSON.parse(localStorage.getItem('addedFreeProducts'));

      if (localStorage.getItem('addedFreeProducts') && Object.keys(localStorageParse).length && this.state.paidProducts > 0) {
        this.state.addedFreeProducts = localStorageParse;
      } else {
        localStorage.setItem('addedFreeProducts', JSON.stringify({}));
      }

      if (products.length) {
        this.state.freeBottomProducts = _toConsumableArray(products).map(function (card) {
          return card.dataset.variantId;
        });
      }
    }
  }, {
    key: "addToCartProducts",
    value: function addToCartProducts(products) {
      var _this12 = this;

      var cartItems = products.reduce(function (acc, product) {
        acc.push({
          id: "".concat(product.id),
          quantity: product.quantity
        });
        return acc;
      }, []);
      if (!cartItems.length) return;
      var data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: cartItems,
          sections: this.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        })
      };
      setTimeout(function () {
        return fetch("".concat(window.location.origin, "/cart/add.js"), data).then(function (response) {
          return response.json();
        }).then(function (response) {
          _this12.renderContents(response);
        });
      }, 500);
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this13 = this;

      var freeProductButtons = this.querySelectorAll(this.selectors.bottomFreeProducts.productCardCta);

      if (freeProductButtons.length) {
        freeProductButtons.forEach(function (button) {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            var id = button.dataset.variantId;
            var quantity = button.dataset.quantity;

            _this13.addToCartProduct(id, quantity);
          });
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this14 = this;

      document.addEventListener('DOMContentLoaded', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee13() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (_this14.querySelector(_this14.selectors.bottomFreeProducts.wrapper)) {
                  _this14.checkPaidProducts();

                  _this14.setBottomFreeProducts();

                  _this14.handlePaidProductsCount();

                  _this14.initListeners();
                }

                _this14.handleCartSync();

                window.state = _this14.state;

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      })));
    }
  }]);

  return CartDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (customElements.get('cart-drawer') === undefined) {
  customElements.define('cart-drawer', CartDrawer);
}
})();

/******/ })()
;